import { TrackingHandler } from '../../tracking/TrackingHandler';
import { ConsentFormHandlerFactory } from '../consent-form-handler/ConsentFormHandlerFactory';
import { getSubmissionHeaders, postJson, prepareStandardSubmission } from '../core/submission';
import { RESERVED_FORM_NAMES } from '../core/field-contract';
import { FormSession } from './FormSession';
export class StandardFormSession extends FormSession {
    endpoint;
    consentPopup;
    constructor(formName, options = {}) {
        if (!formName) {
            throw new Error('FormHandler: a form name is required');
        }
        if (RESERVED_FORM_NAMES.includes(formName)) {
            throw new Error(`FormHandler: the form name "${formName}" is reserved`);
        }
        super(formName);
        this.endpoint = options.endpoint || window.endpoints.forms;
        this.consentPopup = options.consentPopup !== false;
    }
    async submit(data) {
        const trackingHandler = TrackingHandler.getInstance();
        const payload = await this.prepareData(data);
        payload.captcha_solution = await this.captcha.take();
        await prepareStandardSubmission(this.state, payload);
        trackingHandler.formSubmit(this.formName, payload);
        const response = await postJson(this.endpoint, payload, getSubmissionHeaders());
        const body = typeof response.body === 'object' && response.body !== null ? response.body : {};
        trackingHandler.formSubmitResult(this.formName, payload, response.status, body);
        if (response.status < 200 || response.status >= 300) {
            this.captcha.start();
            return {
                status: 'error',
                httpStatus: response.status,
                message: body.message,
                errors: body.errors,
            };
        }
        return {
            status: 'success',
            httpStatus: response.status,
            transactionId: body.i,
            trackingOrderId: body.o,
            consentPopupShown: this.showConsentPopup(payload),
        };
    }
    showConsentPopup(payload) {
        const consentFormHandler = ConsentFormHandlerFactory.getInstance().getHandler();
        if (!this.consentPopup || payload.consentdataprocess_c === 'TRUE' || !consentFormHandler) {
            return false;
        }
        consentFormHandler.displayConsentForm(payload.submit_id_c);
        return document.getElementById('global-consent-modal')?.classList.contains('is-open') === true;
    }
}
